import { Link } from "react-router-dom";
import { useResource } from "@/hooks/useResource";
import { useSession } from "@/state/session";

interface SubscriptionPayload {
  entitlement: {
    can_stream: boolean;
    plan: string;
    status: string;
    max_streams: number;
    max_resolution: string;
    max_profiles: number;
    supports_downloads: boolean;
    has_ads: boolean;
    reason: string;
  };
  subscription: {
    plan_name: string;
    status: string;
    current_period_end: string;
  } | null;
}

export function Account() {
  const { account } = useSession();
  const billing = useResource<SubscriptionPayload>("/api/v1/billing/subscription");

  return (
    <main className="page container" style={{ maxWidth: 780 }}>
      <div style={{ paddingTop: 34 }}>
        <h1>Account</h1>

        <section className="panel" style={{ marginTop: 22 }}>
          <h2 style={{ fontSize: 18, marginBottom: 12 }}>Details</h2>
          <dl className="detail__facts">
            <dt>Email</dt>
            <dd>{account?.email}</dd>
            <dt>Name</dt>
            <dd>{account?.display_name || "-"}</dd>
            <dt>Country</dt>
            <dd>{account?.country}</dd>
            <dt>Roles</dt>
            <dd>{account?.roles.join(", ") || "viewer"}</dd>
          </dl>
        </section>

        <section className="panel" style={{ marginTop: 18 }}>
          <h2 style={{ fontSize: 18, marginBottom: 12 }}>Plan</h2>
          {billing.data ? (
            <dl className="detail__facts">
              <dt>Plan</dt>
              <dd>{billing.data.subscription?.plan_name ?? "None"}</dd>
              <dt>Status</dt>
              <dd>{billing.data.entitlement.status}</dd>
              <dt>Simultaneous streams</dt>
              <dd>{billing.data.entitlement.max_streams}</dd>
              <dt>Maximum quality</dt>
              <dd>{billing.data.entitlement.max_resolution}</dd>
              <dt>Renews</dt>
              <dd>
                {billing.data.subscription
                  ? new Date(billing.data.subscription.current_period_end).toLocaleDateString()
                  : "-"}
              </dd>
            </dl>
          ) : (
            <p style={{ color: "var(--paper-400)" }}>Loading plan…</p>
          )}
        </section>

        <section className="panel" style={{ marginTop: 18 }}>
          <h2 style={{ fontSize: 18, marginBottom: 6 }}>Devices</h2>
          <p style={{ color: "var(--paper-300)", fontSize: 14 }}>
            On your TV, open Hayfish and choose “Sign in”. It shows a six-character code; enter it
            here to sign that device in.
          </p>
          <Link className="btn btn--ghost" to="/link">
            Enter a TV code
          </Link>
        </section>
      </div>
    </main>
  );
}
